<script>
import DivSelector from '@components/general/division-selection.vue'
import { getSessionKey, setSessionKey } from '@helpers/browser-storage'
export default {
  components: { DivSelector },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      types: [
        { value: 'AMBASSADORS', title: 'ambassadors' },
        { value: 'TEACH_START', title: 'teach start' },
        { value: 'SUB_BUBBLES', title: 'sub bubbles' },
      ],
      date: '',
      menu1: false,
      dateFormatted: '',
      selectedType: 0,
      selectedOptions: {
        type: 'SUB_BUBBLES',
        id: '-1',
        level: 'mine',
        date: '2022-12-12',
      },
    }
  },

  created() {
    // get from storage
    if (getSessionKey('candidate-guaranteed-filter') !== null) {
      this.selectedOptions = getSessionKey('candidate-guaranteed-filter')
    }

    this.dateFormatted = this.selectedOptions.date

    // set selected type highlighted option
    for (var x = 0; x < this.types.length; x++) {
      if (this.types[x].value === this.selectedOptions.type) {
        this.selectedType = x
        break
      }
    }
    this.emitSelectedOptions()
  },
  methods: {
    datePickerInput: function (i) {
      this.menu1 = false
      this.dateFormatted = this.date
      this.selectedOptions.date = this.date
      this.emitSelectedOptions()
    },
    clicked: function (i) {
      this.selectedOptions.type = i.value
      this.emitSelectedOptions()
    },
    parseDate: function (i) {
      return i
    },
    emitSelectedOptions: function () {
      setSessionKey('candidate-guaranteed-filter', this.selectedOptions)
      this.$emit('guaranteed-filters-changed', this.selectedOptions)
    },
    typeChanged: function () {
      var newType = 'AMBASSADOR'
      this.selectedOptions.type = newType
      this.emitSelectedOptions()
    },
    dateChanged: function () {
      var newDate = '2022-12-12'
      this.selectedOptions.date = newDate
      this.emitSelectedOptions()
    },
    divisionChanged: function (i) {
      // i = {type:'xxx', id:''}

      this.selectedOptions.level = i.type
      this.selectedOptions.id = i.id
      this.emitSelectedOptions()
    },
  },
}
</script>

<template>
  <v-row>
    <v-col>
      <DivSelector
        :disabled="disabled"
        @changed-division="divisionChanged"
      ></DivSelector>
    </v-col>
    <v-col>
      <v-menu
        ref="menu1"
        v-model="menu1"
        :disabled="disabled"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateFormatted"
            :disabled="disabled"
            label="Date"
            persistent-hint
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          :disabled="disabled"
          no-title
          @input="datePickerInput"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col class="text-right">
      <v-btn-toggle v-model="selectedType" mandatory>
        <v-btn
          v-for="i in types"
          :key="i.value"
          :disabled="disabled"
          @click="clicked(i)"
        >
          {{ i.title }}
        </v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>
</template>
